
import { useNavigate } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
// import { GrayOktaRoutes } from "./gray-okta-portal/routes/GrayOktaRoutes";
import config from "../config/config-okta";
import AppRouter from "../AppRouter";
import { ExploreProvider } from "../Context/ExploreContext";
import { ChatProvider } from "../Context/ChatContext";
import { UserProvider } from "../Context/UserContext";
import { Provider } from 'react-redux';
import store from "../store";
const oktaAuth = new OktaAuth(config.oidc);


export const GrayOktaPortalApp = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <UserProvider>
        <ExploreProvider>
          <ChatProvider>
            <Provider store={store}>
              <AppRouter />
            </Provider>
          </ChatProvider>
        </ExploreProvider>
      </UserProvider>

    </Security>
  );
  // <AppRouter />;
};
